import { IResult } from '../serverApi/types/IResponse';

/**
 * Helper function that rejects a promise if the result is a 200,
 * but contains an error object inside.
 *
 * The server responds with a 400 with most known exceptions,
 * however for unknown exceptions it returns a 200.
 */
export function rejectIfResultContainsError(result: IResult) {
  if (result?.errors?.length) {
    // Return only the first error code
    return Promise.reject(result.errors[0].code);
  }

  return result;
}

/**
 * Helper function that rejects a promise if any of the results is a 200,
 * but contains an error object inside.
 *
 * The server responds with a 400 with most known exceptions,
 * however for unknown exceptions it returns a 200.
 */
export function rejectIfResultsContainError(results: IResult[]) {
  const errorCodes = results.map(result => result?.errors?.[0].code);

  if (errorCodes.some(code => code !== undefined)) {
    return Promise.reject(errorCodes);
  } else {
    return results;
  }
}
